<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <!-- start: PAGE TITLE -->
      <section id="page-title" style="background-color: #d1d1d1;">
        <div class="row">
          <div class="col-sm-10">
            <h1 class="mainTitle">All Day Care Appointments</h1>
          </div>
          <div class="col-sm-2">
            <router-link v-if="hasPermission('day-care-appointments create')" style="margin-right: 10px"
              class="btn btn-primary" :to="{ name: 'create-infoDayService' }">create</router-link>

          </div>

        </div>
      </section>
      <!-- end: PAGE TITLE -->
      <!-- start: DYNAMIC TABLE -->
      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-12">

            <div v-if="infoDayServices.length > 0">
              <MyTable :columns="columns" :actions="true">
                <tr v-for="(infoDayService, index) in infoDayServices" :key="index">
                  <th scope="row">{{ infoDayService.id }}</th>
                  <td>{{ infoDayService.info_service.name ?? 'N/A' }}</td>
                  <td>{{ infoDayService.day_service.name_en ?? 'N/A' }}</td>
                  <td>{{ infoDayService.price ?? 'N/A' }}</td>
                  <!-- <td>
                    <div v-for="(group, groupIndex) in infoDayService.days.filter(day => day.availability === 1)"
                      :key="groupIndex">
                      <p>{{ group.day.name_en }}</p>
                    </div>
                  </td> -->
                  <td>
                    <div v-if="infoDayService.days.some(day => day.availability === 1)">
                      All WeekDays Except :
                      <div v-for="(group, groupIndex) in infoDayService.days.filter(day => day.availability === 0)"
                        :key="groupIndex">
                        <span>{{ group.day.name_en }}</span>
                      </div>
                    </div>
                    <p v-else>No available days</p>
                  </td>
                  <td>{{ infoDayService.from + ' - ' + infoDayService.to }}</td>
                  <td>
                    <button class="me-2 btn btn-danger" v-if="hasPermission('day-care-appointments delete')"
                      @click="deleteInfoDayService(infoDayService.id)">
                      Delete
                    </button>
                    <router-link class="btn btn-primary spacing" v-if="hasPermission('day-care-appointments update')"
                      :to="{ name: 'edit-infoDayService', params: { id: infoDayService.id } }">
                      Edit
                    </router-link>
                  </td>
                </tr>
              </MyTable>
            </div>
            <div v-else class="alert alert-info">
              No Appointments found.
            </div>
          </div>
        </div>
      </div>
      <!-- end: DYNAMIC TABLE -->
    </div>
  </div>
</template>

<script>
import axios from "../../Axios";
import { store } from "../../Store";
import $ from 'jquery'; // Import jQuery
import MyTable from "../MyTable//MyTable.vue"; // Import your MyTable component

export default {
  name: "AllInfoDayServices",
  components: {
    MyTable,
  },
  data() {
    return {
      dataTable: [],
      infoDayServices: [],
      meta: {},
      searchTerm: "",
      columns: [
        { label: '#', key: 'id' },
        { label: 'Hospital Name', key: 'info_service.name' },
        { label: 'DayCare Name', key: 'DayService.name_en' },
        { label: 'Price', key: 'price' },
        { label: 'Days', key: 'days.name_en' },
        { label: 'Hour', key: 'from - to' },
      ],
    };
  },

  async created() {
    this.fetchInfoDayService();
  },

  computed: {
    hasPermission() {
      return (permission) => store.hasPermission(permission);
    },
    filteredInfoDayService() {
      if (!this.searchTerm) {
        return this.infoDayServices;
      }
      const term = this.searchTerm.toLowerCase();
      return this.infoDayServices.filter(
        (infoDayService) =>
          infoDayService.name.toLowerCase().includes(term)
      );
    },
  },

  methods: {

    // fetch deleteInfoDayServices
    async fetchInfoDayService() {
      try {

        const response = await axios.get(
          `/admin/admin/info-day-service/all`
        );
        console.log(response);
        this.infoDayServices = response.data.data;
        console.log(" fetching info-day-service:", this.infoDayServices);
        this.meta = response.data.meta;
        this.$nextTick(() => {
          this.initializeDataTable(); // Initialize DataTable after fetching users
        });
      } catch (error) {
        console.error("Error fetching info-day-service:", error);
      }
    },
    initializeDataTable() {
      this.$nextTick(() => {
        $('.sample_1').DataTable(); // Initialize DataTable
      });
    },
    deleteInfoDayService(id) {
      console.log("delete info-day-service id: ", id);
      axios
        .delete(`/admin/admin/info-day-service/delete?id=${id}`)
        .then((response) => {
          console.log(response.data);
          this.fetchInfoDayService();
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },

};
</script>
<style scoped>
.table {
  margin-top: 10px;
}

.spacing {
  margin-left: 10px !important;
}
</style>